module.exports = __webpack_public_path__ + "img/2423.1987ca59.gif";